import axios from 'axios';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000, // Request timeout (10 seconds)
  headers: {
    'Content-Type': 'application/json', // Default content type
  },
});

// Request interceptor
apiClient.interceptors.request.use((config) => {
  // Add authorization token or other custom headers if needed
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const handleAuthFailure = () => {
  localStorage.clear();
  globalThis.location.href = '/';
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 403) {
      handleAuthFailure();
    }
    // Ensure that the promise is rejected with an Error object
    return Promise.reject(
      error instanceof Error ? error : new Error(error.message)
    );
  }
);

export default apiClient;
